import { render, staticRenderFns } from "./GBGhostSchedule.vue?vue&type=template&id=b3b43310&"
import script from "./GBGhostSchedule.vue?vue&type=script&lang=js&"
export * from "./GBGhostSchedule.vue?vue&type=script&lang=js&"
import style0 from "./GBGhostSchedule.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports